/* eslint-disable react-hooks/exhaustive-deps */
import { ButtonStyled } from "../OfficeDetail/style";
import { CalendarWrapper, WrapperBack } from "./style";
import { DateTime } from "luxon";
import { Loading } from "../../../../components/Loaders/Loading";
import { sumDays } from "lib/date";
import Calendar from "react-calendar";
import React, { useEffect, useGlobal, useState } from "reactn";

const CalendarComponent = ({
	onBack = () => {},
	onSelect = () => {},
	onContinue = () => {},
	onGetBlocks = () => {},
	maxBookableDays = 90,
	dateSelected,
	isLoading,
	keyBlocks,
	lines,
	office,
	folder,
}) => {
	const [language] = useGlobal("language");
	const [value, onChange] = useState(new Date());

	const actualDate = new Date();
	const dateToChange = new Date();
	const logo = folder
		? `https://media.zeroq.cl/images/web/${office.slug}/folders/${folder
				.toLowerCase()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "")
				.replace(/\s+/g, "_")}/image.png`
		: null;

	useEffect(() => {
		onGetBlocks({
			from: DateTime.fromJSDate(actualDate).toFormat("yyyy-MM-dd"),
			to: DateTime.fromJSDate(actualDate)
				.endOf("month")
				.toFormat("yyyy-MM-dd"),
		});
	}, []);

	const handleGetDisabledTitle = (date) => {
		const dateDayFormated =
			DateTime.fromJSDate(date).toFormat("yyyy-MM-dd");

		const findDateByBlock = keyBlocks.find(
			(item) => item.date === dateDayFormated
		);

		return !findDateByBlock;
	};

	const handleOnClickDay = (date) => {
		onChange(date);
		onSelect(DateTime.fromJSDate(date).toFormat("yyyy-MM-dd"));
	};

	const handleOnChange = ({ action, activeStartDate, value, view }) => {
		if (action === "next" || action === "prev") {
			const isMonthActive =
				DateTime.now().toFormat("MM") ===
				DateTime.fromJSDate(activeStartDate).toFormat("MM");

			onChange(isMonthActive ? actualDate : activeStartDate);

			onGetBlocks({
				from: isMonthActive
					? DateTime.now().toFormat("yyyy-MM-dd")
					: DateTime.fromJSDate(activeStartDate).toFormat(
							"yyyy-MM-dd"
					  ),
				to: DateTime.fromJSDate(activeStartDate)
					.endOf("month")
					.toFormat("yyyy-MM-dd"),
			});
		}
	};

	if (isLoading) return <Loading full />;

	return (
		<CalendarWrapper>
			{logo && (
				<div className={"img-container"}>
					{logo && (
						<img
							src={logo}
							alt="img-container"
							onError={(e) => {
								e.target.style.display = "none";
							}}
						/>
					)}
				</div>
			)}
			<div className={"calender-container"}>
				<Calendar
					locale={language.selected ?? "es-CL"}
					onActiveStartDateChange={handleOnChange}
					value={value}
					minDetail={"month"}
					minDate={actualDate}
					onClickDay={handleOnClickDay}
					maxDate={sumDays(dateToChange, maxBookableDays)}
					tileDisabled={({ activeStartDate, date, view }) =>
						handleGetDisabledTitle(date)
					}
				/>
			</div>
			<WrapperBack>
				<ButtonStyled typeForStyled="backgroundless" onClick={onBack}>
					Atrás
				</ButtonStyled>
				<ButtonStyled
					typeForStyled="primary"
					onClick={onContinue}
					disabled={!dateSelected}
				>
					Continuar
				</ButtonStyled>
			</WrapperBack>
		</CalendarWrapper>
	);
};

export default CalendarComponent;
